import { FC, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import { isModuleActive } from '../../views/LogisticServices/utils/general.utils';
import { IsidebarModule, getSidebarModules } from './SidebarModules';
import useOnlyDevelopers from '../../state/setOnlyDevelopers';
import Logout from './Logout/LogoutModal';
import './BackofficeSidebar.scss';

const BackofficeSidebar: FC<ISideBar> = ({ infoSideBar }: ISideBar) => {
  const { onlyDevelopers } = useOnlyDevelopers();
  const { push } = useHistory();

  const [selectedModule, setSelectedModule] = useState(infoSideBar?.position || 'home');
  const [showLogoutModal, setShowLoggoutModal] = useState(false);

  const SIDEBAR_MODULES = getSidebarModules(selectedModule, onlyDevelopers);

  const openInNewTab = (url: string): void => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const changeSidebarModule = (sidebarModule: IsidebarModule, isActive: boolean) => {
    const { name, route, externalRoute } = sidebarModule;
    if (!name || selectedModule === name || !isActive) return;
    if (externalRoute) {
      openInNewTab(externalRoute)
      return;
    }
    setSelectedModule(name);
    if (route) push(route);
  };

  const closeLogoutModal = () => setShowLoggoutModal(false);
  const openLogoutModal = () => setShowLoggoutModal(true);

  const generateSidebarModuleUI = (sidebarModule: IsidebarModule) => {
    if (!sidebarModule.show) return null;

    const isActive = isModuleActive(sidebarModule.name);
    const inactiveStyles = isActive ? '' : 'inactive';
    const selectedStyles = selectedModule === sidebarModule.name ? 'selectItem' : '';
    const className = `sidebarModuleMenu ${selectedStyles} ${inactiveStyles}`;
    const handleClick = () => changeSidebarModule(sidebarModule, isActive);

    return (
      <div key={uuid()} className={className} onClick={handleClick}>
        <div className="moduleIcon">{sidebarModule?.img}</div>
        <div className="moduleTitle">{sidebarModule?.title}</div>
      </div>
    );
  };

  return (
    <div id="backofficeSidebar">
      {showLogoutModal && <Logout closeModalCallback={closeLogoutModal} />}
      {SIDEBAR_MODULES.map(item => generateSidebarModuleUI(item))}
      <div className="logoutButton" onClick={openLogoutModal}>
        Cerrar sesión
      </div>
    </div>
  );
};

export default BackofficeSidebar;

interface IPosition {
  position?: string;
}

interface ISideBar {
  infoSideBar?: IPosition;
}
